import React from "react";

import styles from "./style.module.css";

import { Popover } from "react-bootstrap";

export class OverlayData extends React.PureComponent {
  normalize(val, max, min) {
    return ((val - min) / (max - min)) * 100;
  }

  getCountFromValue(field, value) {
    return field && field.data && field.data.filter((d) => d.value === value).length > 0
      ? field.data.filter((d) => d.value === value)[0].count
      : undefined;
  }

  determineLevelImportance = () => {
    const { valueHover, isContinuous, baseline, bar } = this.props;

    if (!valueHover || (valueHover && !valueHover.value)) {
      return bar.left.toFixed(2) + "%";
    }

    let displayValue;
    if (baseline === undefined) {
      displayValue = ((bar.left / 100) * this.normalize(valueHover.value, bar.left, 0) * 100).toFixed(2) + "%";
    } else if (baseline !== undefined) {
      displayValue = isContinuous ? valueHover.value.toFixed(2) : (valueHover.value * 100).toFixed(2) + "%";
    }

    return displayValue ? <React.Fragment>{displayValue}</React.Fragment> : null;
  };

  render() {
    const {
      bar,
      valueHover,
      baseline,
      field,
      fieldValueCounts,
      outcome,
      rowCount,
      isContinuous,
      isQuickRun,
      showLevelImportance
    } = this.props;

    const count = valueHover && valueHover.label ? this.getCountFromValue(field, valueHover.label) : undefined;

    const totalPct = rowCount && count !== undefined ? ((count / rowCount) * 100).toFixed(2) + "%" : undefined;

    const column = field?.label;
    const value = valueHover?.label;

    const valueCount = fieldValueCounts?.[column]?.[value];
    const colCount =
      fieldValueCounts?.[column] &&
      Object.keys(fieldValueCounts?.[column]).reduce((acc, vlabel) => {
        const vCount = fieldValueCounts[column][vlabel];
        if (!isNaN(vCount)) {
          return acc + vCount;
        }
        return acc;
      }, 0);

    const countPct =
      colCount && valueCount !== undefined ? ((valueCount / colCount) * 100).toFixed(2) + "%" : undefined;

    return (
      <div>
        <div className={styles.tooltipHolder}>
          <span className={styles.tooltipInfo}>
            <span className={styles.tooltipInfoContent}>{bar.leftModel}</span>
            <span>{":"}</span>
          </span>
          <span className={styles.tooltipNumber}>
            {showLevelImportance ? this.determineLevelImportance() : bar.left.toFixed(2) + "%"}
          </span>
        </div>

        {valueHover && baseline === undefined && (
          <div className={styles.tooltipHolder}>
            {valueHover.label && (
              <span className={styles.tooltipInfo}>
                <span className={styles.tooltipInfoContent}>{valueHover.label}</span>
                <span>{":"}</span>
              </span>
            )}
            {valueHover.value && (
              <span className={styles.tooltipNumber}>
                {((bar.left / 100) * this.normalize(valueHover.value, bar.left, 0) * 100).toFixed(2) + "%"}
              </span>
            )}
            {valueHover.extra && valueHover.extra}
          </div>
        )}
        {valueHover &&
          baseline !== undefined &&
          (isContinuous ? (
            <div className={styles.tHolder}>
              <span>{"When "}</span>
              <span style={{ fontWeight: "bold" }}>{bar.label}</span>
              <span>{" is "}</span>
              <span style={{ fontWeight: "bold" }}>{valueHover.label}</span>
              <span>
                {outcome
                  ? " the predicted value of " +
                    outcome +
                    " " +
                    (valueHover.value > 0 ? "increases by " : "decreases by ")
                  : ""}
              </span>
              <span style={{ fontWeight: "bold" }}>{Math.abs(valueHover.value).toFixed(2)}</span>
              <span>{" compared to the average."}</span>
              <div>
                <span>{"("}</span>
                <span style={{ fontWeight: "bold" }}>{baseline.toFixed(2)}</span>
                <span>{" to "}</span>
                <span style={{ fontWeight: "bold" }}>{(baseline + valueHover.value).toFixed(2)}</span>
                <span>{")"}</span>
              </div>
            </div>
          ) : (
            <div className={styles.tHolder}>
              <span>{"When "}</span>
              <span style={{ fontWeight: "bold" }}>{bar.label}</span>
              <span>{" is "}</span>
              <span style={{ fontWeight: "bold" }}>{valueHover.label}</span>
              <span>
                {(isQuickRun ? " probability " : " prediction score ") +
                  (valueHover.value > 0 ? "increases " : "decreases ")}
              </span>
              <span style={{ fontWeight: "bold" }}>{Math.abs(valueHover.value * 100).toFixed(2) + "%"}</span>
              <span>{" compared to the average."}</span>
              <div>
                <span>{"("}</span>
                <span style={{ fontWeight: "bold" }}>{(baseline * 100).toFixed(2) + "%"}</span>
                <span>{" to "}</span>
                <span style={{ fontWeight: "bold" }}>{(baseline * 100 + valueHover.value * 100).toFixed(2) + "%"}</span>
                <span>{")"}</span>
              </div>
            </div>
          ))}
        {valueHover && valueCount !== undefined && (
          <div>
            <div>
              <span style={{ marginRight: "3px" }}>{"Count: "}</span>
              <span style={{ fontWeight: "bold" }}>{valueCount}</span>
              <span>{" ("}</span>
              <span style={{ fontWeight: "bold" }}>{countPct}</span>
              <span>{" of "}</span>
              <span>{colCount}</span>
              <span>{" rows)"}</span>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default OverlayData;
